import React from "react";

import {
    Create,
    SimpleForm,
    TextInput,
} from 'react-admin';

const ClassCreate = (props) => (
    <Create {...props} title="Create class">
        <SimpleForm>
            <TextInput disabled source="id" />
            <TextInput source="class_name" />
            <TextInput source="class_code" />
            <TextInput source="grade" />
        </SimpleForm>
    </Create>
);

export default ClassCreate;